module.exports = __webpack_public_path__ + "img/racecourse-mauritius-turf-1250.ed19f844.svg";